// US phone helpers. Display + store as (xxx) xxx-xxxx when the value is a clean
// 10-digit (or 1+10) US number; otherwise leave the input untouched.
export function formatPhone(value) {
  if (!value) return value || "";
  const d = String(value).replace(/\D/g, "");
  let n = d;
  if (n.length === 11 && n.startsWith("1")) n = n.slice(1);
  if (n.length !== 10) return value; // non-US / irregular — leave as entered
  return `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;
}

// Live formatting as the user types (partial input allowed).
export function formatPhoneLive(value) {
  const raw = String(value || "");
  let d = raw.replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  if (d.length > 10) return raw; // likely international — don't fight the user
  if (d.length === 0) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export const normalizePhone = formatPhone;
